import { CSSProperties } from 'react';

export const PopupMenuEmptyMessage = ({ styles, message }: { styles?: CSSProperties, message: string }) => {
   return (
      <div style={{ textAlign: 'center', padding: '4px 8px 4px' , fontSize: '0.875rem', ...styles }}>
        {message}
      </div>
    );
};